import Proxy from '../Proxy';

class StatsCreatedProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('stats/created', parameters);
  }

  showMy() {
    return this.submit('get', `${this.endpoint}/show-my`);
  }

  list() {
    return this.submit('get', `${this.endpoint}/by-period`);
  }
}

export default StatsCreatedProxy;
